import { CalorieAmountDisplay } from 'menu/components/Calories';
import { Keywords } from 'menu/components/Keywords';
import { MenuItemDescription } from 'menu/components/MenuItemDescription';
import { ChoicePriceLabel } from 'menu/components/MenuModal/ModalComponents/ChoicePriceLabel';
import { MinimumAgeBadge } from 'menu/components/MinimumAge';
import {
  DisplayRecord,
  ChoiceGroupDisplayRecord,
  AztecPortion,
  AztecProduct,
} from 'types/models';
import { emptyStringFallback } from 'utils/stringUtilities';

interface ChoiceDetailsProps {
  choiceDisplayRecord?: DisplayRecord | ChoiceGroupDisplayRecord;
  keywords?: number[];
  minimumAge?: number;
  nameOverride?: string;
  portion?: AztecPortion;
  priceToDisplay?: number;
  productToUse?: AztecProduct;
  outOfStock?: boolean;
}

export const ChoiceDetails: React.FC<ChoiceDetailsProps> = ({
  choiceDisplayRecord,
  keywords,
  minimumAge,
  nameOverride,
  portion,
  priceToDisplay,
  productToUse,
  outOfStock,
}) => {
  return (
    <>
      <div className="choice-details">
        <div className="choice-name">
          {nameOverride ||
            emptyStringFallback(
              choiceDisplayRecord?.name,
              productToUse?.eposName,
            )}
          {minimumAge ? <MinimumAgeBadge minimumAge={minimumAge} /> : null}
        </div>
        <div className="calories-keywords">
          <CalorieAmountDisplay
            displayRecord={choiceDisplayRecord as DisplayRecord}
            portions={portion ? [portion] : []}
          />
          {keywords ? <Keywords list={keywords} /> : null}
        </div>
        {choiceDisplayRecord?.description ? (
          <MenuItemDescription description={choiceDisplayRecord?.description} />
        ) : null}
      </div>
      {priceToDisplay && priceToDisplay !== 0 && !outOfStock ? (
        <ChoicePriceLabel priceToDisplay={priceToDisplay} />
      ) : null}
    </>
  );
};
